<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="title" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">


    @if (type !== 'support.concierge_task') {
      <tidy-row [align]="'center'">
        @if (type === 'support.other' && !dontShowOtherText) {
          <tidy-text
            [body]="otherText" />
        }
        <tidy-text
          [body]="'We expect to reply within'" /><span>&nbsp;</span>
          <tidy-text
            [body]="replyTime" /><span>&nbsp;</span>
            <tidy-text
              [body]="'. We will reply both in the app and to your email'" /><span>&nbsp;</span>
              <tidy-text
                [body]="email + '.'" />
            </tidy-row>
          }

          @if (isAddingPro) {
            <tidy-row>
              <tidy-text
                [body]="'Let us know:'" />
              <tidy-text
                [body]="'<li>Contact info of pro(s) (name, email, phone, etc)</li>'" />
              <tidy-text
                [body]="'<li>Which properties/services to add to</li>'" />
              <tidy-text
                [body]="'<li>Anything else we should know!</li>'" />
            </tidy-row>
          }

          @if (isAddingRoomItem) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Send us a list of all your current inventory, either with current stock levels or not. We will load it for you, typically within 1 business day. We email you when done!'" />
            </tidy-row>
          }

          @if (isAddingToDoList) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Send us your current checklists and instructions. We will load it for you, typically within 1 business day. We email you when done! Edit as needed from there.'" />
            </tidy-row>
          }

          @if (type === 'support.concierge_task' && !isAddingPro && !isAddingRoomItem && !isAddingToDoList && !isWorkflow) {
            <tidy-row>
              <tidy-text
                [body]="'Tasks are where you can specify anything you need from TIDY. Our AI and concierge teams will figure out how to get it done for you. We accept anything relating to coordinate cleaning and maintenance at your properties.'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'<b>Examples:</b>'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Can you add this checklist to my account?'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Can you set up 3 vendors to come and clean the carpets, complete a regular cleaning, and complete an inspection?'" />
            </tidy-row>
          }

          @if (isAutoAssign) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Please add to your message below which services you want to auto assign to this pro.'" />
            </tidy-row>
          }

          @if (isWorkflow) {
            <tidy-row [align]="'center'">
              <tidy-text
                [body]="'Please let us know what workflow you want to create. For example: when a job is completed, create a concierge action.'" />
            </tidy-row>
          }

          <tidy-card>
            <form [formGroup]="form">
              <tidy-row class="field-top-padding field-bottom-padding">
                <tidy-input
                  [label]="type === 'support.concierge_task' ? 'Task name' : 'Subject'"
                  [icon]="'assets/svg/mail-outline.svg'"
                  formControlName="subject"
                  [form]="form.controls.subject"
                  [submitted]="submitted"
                  [errorMessage]="'Please enter your first name.'" />
              </tidy-row>
              <tidy-row class="field-bottom-padding">
                <tidy-textarea
                  [label]="getTaskDescriptionText()"
                  formControlName="message"
                  [form]="form.controls.message"
                  [submitted]="submitted"
                  [icon]="'assets/svg/information-circle-outline.svg'"
                  [errorMessage]="'Please enter a message'" />
              </tidy-row>
              @if (addingEmailCC) {
                <tidy-row>
                  <tidy-input
                    [label]="'Email CC'"
                    [icon]="'assets/svg/person-outline.svg'"
                    formControlName="email"
                    [form]="form.controls.email"
                    [submitted]="submitted"
                    [errorMessage]="'Please enter a valid email'" />
                </tidy-row>
              }
            </form>
            @if (!addingEmailCC && type !== 'support.concierge_task') {
              <tidy-row>
                <tidy-text
                  [actionBody]="'Add Email CC'"
                  (action)="addEmailCC()"
                  class="link" />
              </tidy-row>
            }
            <tidy-row>
              <tidy-text
                [actionBody]="'Add Attachment'"
                (action)="addAttachment()"
                class="link" />
            </tidy-row>
            @if (attachments.length) {
              <tidy-row class="field-top-padding">
                <tidy-row>
                  <tidy-text
                    [body]="'Attachments:'" />
                </tidy-row>
                @for (attachment of attachments; track attachment; let i = $index) {
                  <tidy-two-column-row>
                    <tidy-text
                      [body]="attachment.filename" />
                    <tidy-text
                      [actionBody]="'remove'"
                      (action)="removeAttachment(i)"
                      class="link red" />
                  </tidy-two-column-row>
                }
              </tidy-row>
            }
          </tidy-card>

          @if (errorMessage) {
            <tidy-error-message
              [text]="errorMessage" />
          }

          <tidy-button
            [text]="type === 'support.concierge_task' ? 'Create Task' : 'Send to Concierge'"
            [action]="boundSend"
            class="primary" />

        </tidy-wrapper>
      </ng-template>

      @if (!isRightSideContent) {
        <app-scroll-wrapper [templateContent]="content" />
      }

      @if (isRightSideContent) {
        <ion-content class="ion-content-right-column">
          <ng-container *ngTemplateOutlet="content" />
        </ion-content>
      }
